import React from 'react';
import { Button, Flex, Tag } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-light-svg-icons';
import { values } from 'lodash';
import './FoldableTagList.sass';
import { getScoreColor } from 'utils/ranking';

interface FoldableTagListProps {
  title: string;
  tags: Array<{ id: string; name: string, content?: React.ReactNode }>;
  usedTags?: { [key: string]: boolean };
  selectedTags?: string[];
  emptyMessage: string;
  className?: string;
  onTagClick?: (tagId: string) => void;
}

const FoldableTagList: React.FC<FoldableTagListProps> = ({
  title,
  tags,
  usedTags = {},
  selectedTags = [],
  emptyMessage,
  className = '',
  onTagClick = () => { }
}) => {
  const [showAllTags, setShowAllTags] = React.useState<boolean>(false);

  // Determine if we need a toggle button (if there are unused tags)
  const hasUnusedTags = tags.length > 0 && (values(usedTags).length !== tags.length);

  return (<>
    <Flex align="center" className="mb-05">
      <strong
        className="foldable-tag-list__title"
        style={{ marginRight: '1rem', whiteSpace: 'normal', wordBreak: 'break-word' }}
      >
        {title}
      </strong>

      {tags && tags.length > 0 && hasUnusedTags && (
        <div className="ml-auto">
          <Button
            shape="circle"
            className="mini noselection"
            onClick={() => setShowAllTags(!showAllTags)}
          >
            <FontAwesomeIcon
              icon={!showAllTags ? faPlus : faMinus}
            />
          </Button>
        </div>
      )}
    </Flex>

    <div className={`text-left ${className}`}>
      {((tags && tags.length > 0 && showAllTags) || values(usedTags).length > 0) ? (
        tags.map((tag, index) => {
          // Only show if tag is used or showAllTags is true
          return (showAllTags || usedTags[tag.id]) && (
            <Tag.CheckableTag
              key={`tag-${index}`}
              checked={selectedTags.includes(tag.id)}
              onClick={() => onTagClick && onTagClick(tag.id)}
              className={[
                'tag noselection',
                usedTags[tag.id] ? "used" : "unused"
              ].join(' ')}
            >
              {tag.trend !== undefined && <div
                className={
                  'Trend v' + tag.trend
                }
                style={
                  tag.trend == '50'
                    ? {}
                    : {
                      background:
                        getScoreColor(
                          tag.trend
                        )
                    }
                }
              ></div>}

              {tag.name || tag.content}
            </Tag.CheckableTag>
          );
        })
      ) : (
        <div className="text-center opacity-50" style={{ color: 'var(--color-text-base)' }}>
          {emptyMessage}
        </div>
      )}
    </div>
  </>
  );
};

export default FoldableTagList;